// @flow
import { connect } from "react-redux";
import BlogDialog from "./view";
import Dialog from "../dialog";
import Photos from "../blog-card/photos";
import { hideMonth } from "../state/photos/actions";
import { getShowPhotoSummary } from "../state/photos/reducer";

export default connect(
    state => ({
        photoSummary: getShowPhotoSummary(state.photos),
        Dialog,
        Photos
    }),
    dispatch => ({
        onHide: () => dispatch(hideMonth())
    })
)(BlogDialog);



// WEBPACK FOOTER //
// ./src/photos-dialog/index.js